export const ReportButton = () => {
  return (
    <div className="flex items-center gap-2 cursor-pointer text-muted-foreground hover:text-primary transition-colors">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 21v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8" />
        <path d="M5 21a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2" />
        <path d="M12 11V3" />
        <path d="M12 3l-3 3" />
        <path d="M12 3l3 3" />
      </svg>

      <span className="text-sm font-medium">Report</span>
    </div>
  );
};
